import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const getBorderColorOptions = ({
  defaultValue = "#000000",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "color",
  value: defaultValue,
});

export const getBorderWidthOptions = ({
  defaultValue = "1",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "slider",
  value: defaultValue,
});

export const getBorderStyleOptions = ({
  defaultValue = "solid",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "select",
  value: defaultValue,
});
